import { MessageCircle } from 'lucide-react'
import type { PricingKind } from '@/lib/whatsapp'
import { Button } from '@/components/ui/button'

interface WhatsAppPricingButtonsProps {
  onSelect: (kind: PricingKind) => void
  disabled?: boolean
  label?: string
}

export function WhatsAppPricingButtons({ onSelect, disabled, label = 'Consultar por WhatsApp' }: WhatsAppPricingButtonsProps) {
  return (
    <div className="grid gap-1.5">
      <p className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
        <MessageCircle className="size-3.5" />
        {label}
      </p>
      <div className="grid grid-cols-2 gap-2">
        <Button type="button" variant="outline" size="lg" disabled={disabled} onClick={() => onSelect('wholesale')}>
          Al por mayor
        </Button>
        <Button type="button" size="lg" disabled={disabled} onClick={() => onSelect('retail')}>
          Al detal
        </Button>
      </div>
    </div>
  )
}
